import { Fragment, lazy } from "react"
import { Route } from "react-router"

import { PageType } from "@app/config/pageTypes"
import { RouteMetaManager } from '@app/meta/RouteMetaManager'
import { SentryRoutes } from '@shared/lib/sentry'
import TwoColumnLayout from "@shared/ui/layout/TwoColumnLayout"
import Slider from "@widgets/slider/Slider"

import EnsureTrailingSlash from './EnsureTrailingSlash'

const ConfirmForgotPasswordPage = lazy(() => import('@pages/forgot-password/confirm/ConfirmForgotPasswordPage'))
const ForgotPasswordPage = lazy(() => import('@pages/forgot-password/ForgotPasswordPage'))
const SuccessRestorePasswordPage = lazy(() => import('@pages/forgot-password/success/SuccessRestorePasswordPage'))
const LoginPage = lazy(() => import('@pages/login/LoginPage'))
const NotFountPage = lazy(() => import('@pages/not-found/NotFoundPage'))
const ConfirmEmailPage = lazy(() => import('@pages/sign-up/confirm-email/ConfirmEmailPage'))
const SignUpFormPage = lazy(() => import('@pages/sign-up/sign-up-form/SignUpFormPage'))
const SignUpPage = lazy(() => import('@pages/sign-up/SignUpPage'))
const ConfirmSignInPage = lazy(() => import('@pages/login/2fa/ConfirmSignInPage'))
const RegistrationPhonePage = lazy(() => import('@pages/sign-up/registration-phone/RegistrationPhonePage'))
const CheckKybPage = lazy(() => import('@pages/sign-up/check-kyb/CheckKybPage'))
const ConfirmPhonePage = lazy(() => import('@pages/sign-up/confirm-phone/ConfirmPhonePage'))
const VerificationPendingPage = lazy(() => import('@pages/sign-up/verification-pending/VerificationPendingPage'))
const MaintenancePage = lazy(() => import('@pages/maintenance/MaintenancePage'))

const AppRouter = () => {
    return (
        <Fragment>
            <RouteMetaManager />

            <SentryRoutes>
                <Route path="*" element={<EnsureTrailingSlash />} />
            </SentryRoutes>
            <SentryRoutes>
                <Route path="/" element={ <EnsureTrailingSlash />} />
                <Route element={<TwoColumnLayout rightComponent={<Slider/>} pageType={PageType.Login} />}>
                    <Route path="login">
                        <Route index element={<LoginPage />} />
                        <Route path="2fa" element={<ConfirmSignInPage />} />
                    </Route>
                </Route>
                <Route element={
                    <TwoColumnLayout rightComponent={<Slider/>}
                        pageType={PageType.ForgotPassword} />
                }>
                    <Route path="forgot-password">
                        <Route index element={ <ForgotPasswordPage /> } />
                        <Route path="confirm" element={<ConfirmForgotPasswordPage />} />
                        <Route path="success" element={<SuccessRestorePasswordPage />} />
                    </Route>
                </Route>
                <Route element={
                    <TwoColumnLayout rightComponent={<Slider/>}
                        pageType={PageType.Registration} />
                }>
                    <Route path="sign-up">
                        <Route index element={<SignUpPage />} />
                        {/*TODO: CLOSE KYB PAGES FOR PERSONAL*/}
                        <Route path=":accountType/*">
                            <Route index element={ <SignUpFormPage /> } />
                            <Route path="confirm-email" element={<ConfirmEmailPage />} />
                            <Route path="confirm-phone" element={ <ConfirmPhonePage /> } />
                            <Route path="registration-phone" element={<RegistrationPhonePage />} />
                            <Route path="check-kyb" element={<CheckKybPage />} />
                            <Route path="verification-pending" element={<VerificationPendingPage />} />
                        </Route>
                    </Route>
                </Route>
                    <Route path="/maintenance" element={ <MaintenancePage /> } />
                <Route path="*" element={<NotFountPage />} />
            </SentryRoutes>
        </Fragment>
    )
}

export default AppRouter
